/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PedestrianDeviceCreate
 */
export interface PedestrianDeviceCreate {
    /**
     * 
     * @type {string}
     * @memberof PedestrianDeviceCreate
     */
    label?: string | null;
    /**
     * The pedestrian device's serial number.
     * 
     * Hexadecimal string with length of 24 bytes. This is expected to be unique.
     * @type {string}
     * @memberof PedestrianDeviceCreate
     */
    hardwareSerialNumber: string;
}

/**
 * Check if a given object implements the PedestrianDeviceCreate interface.
 */
export function instanceOfPedestrianDeviceCreate(value: object): value is PedestrianDeviceCreate {
    if (!('hardwareSerialNumber' in value) || value['hardwareSerialNumber'] === undefined) return false;
    return true;
}

export function PedestrianDeviceCreateFromJSON(json: any): PedestrianDeviceCreate {
    return PedestrianDeviceCreateFromJSONTyped(json, false);
}

export function PedestrianDeviceCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PedestrianDeviceCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'hardwareSerialNumber': json['hardwareSerialNumber'],
    };
}

export function PedestrianDeviceCreateToJSON(json: any): PedestrianDeviceCreate {
    return PedestrianDeviceCreateToJSONTyped(json, false);
}

export function PedestrianDeviceCreateToJSONTyped(value?: PedestrianDeviceCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'hardwareSerialNumber': value['hardwareSerialNumber'],
    };
}

